export default [
  { label: "Status", value: "status" },
  { label: "Numero da NF", value: "number" },
  { label: "Autor", value: "author" },
  { label: "Numero Serial", value: "serial" },
  { label: "Data de emissão", value: "issued_at" },
  { label: "Data de confirmação", value: "confirmed_at" },
  { label: "Data de cancelamento", value: "canceled_at" },
  { label: "Motivo da falha", value: "failure_reason" },
  { label: "Ações", value: "actions", className: "w-24" },
];
